import React from 'react';

const ChooseUsCard = ({ title, description, image_path }) => {
  return (
    <div className="group cursor-pointer relative bg-white p-8 rounded-3xl border border-gray-100 shadow-sm transition-all duration-500 ha:shadow-2xl ha:-translate-y-3 flex flex-col items-center text-center">
      
      {/* Decorative Background Glow (Only shows on hover) */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-50 to-transparent opacity-0 gh:opacity-100 transition-opacity duration-500 rounded-3xl" />

      {/* Image/Icon Container */}
      <div className="relative mb-6">
        <div className="w-20 h-20 bg-gray-50 rounded-2xl flex items-center justify-center transition-all duration-500 gh:bg-brand-500 gh:rotate-[10deg] shadow-inner">
          <img 
            src={image_path} 
            className="w-12 h-12 object-contain transition-all duration-500 gh:brightness-0 gh:invert" 
            alt={title} 
          />
        </div>
        {/* Small floating accent dot */}
        <div className="absolute -top-2 -right-2 w-4 h-4 bg-brand-400 rounded-full scale-0 gh:scale-100 transition-transform duration-500" />
      </div>

      {/* Content */}
      <div className="relative z-10">
        <h4 className="text-xl font-bold text-gray-900 mb-4 tracking-tight transition-colors duration-300 gh:text-brand-700">
          {title}
        </h4>
        <p className="text-gray-500 leading-relaxed text-sm">
          {description}
        </p>
      </div>

      {/* Bottom accent bar */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-1 bg-brand-500 transition-all duration-500 gh:w-1/3 rounded-t-full" />
    </div>
  );
};

export default ChooseUsCard;